import { Box } from "@biom3/react";

export function RewardBackground() {
  return (
    <Box
      sx={{
        backgroundImage:
          "url(/images/rewards/im-key-teaser-anim-compressed.webp)",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        zIndex: 0,
        "&::before": {
          content: '""',
          position: "absolute",
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
          backdropFilter: "blur(50px)",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          zIndex: 1,
        },
      }}
    />
  );
}
